<div class="message-row" [class.message-row--outcoming]="message.outcoming">
  @if (canDisplayAuthor()) {
  <div class="message__avatar">
    <messaging-avatar
      [src]="authorAvatarSrc()"
      [name]="authorDisplayName()"
      [colorSeed]="authorColorSeed()"
      [initialsSize]="2"
      size="28"
      [ngStyle]="{ cursor: authorAvatarSrc() ? 'pointer' : 'default' }"
      (click)="imagesService.openPhoto(authorAvatarSrc() ?? '', undefined, false)">
    </messaging-avatar>
  </div>
  }
  <div class="message-container" #messageElement>
    <div
      class="message"
      [ngClass]="{
        'message-outcoming': !message.outcoming
      }">
      <div class="message__menu" *hasChannelFeature="[ChannelFeatures.canDeleteMessages]">
        @if (message.outcoming && !message?.deliveryStatus?.sending) {
        <mat-icon mat-icon-button [matMenuTriggerFor]="menuMessage" svgIcon="more_vert" class="more-options"></mat-icon>
        }

        <mat-menu #menuMessage>
          <button mat-menu-item (click)="deleteMessage(message)">
            {{ 'NGX-MESSAGING.CHAT.deleteMessage' | translate }}
          </button>
        </mat-menu>
      </div>
      @if (canDisplayAuthor()) {
      <div class="message__header">
        <div class="message__author" [style.color]="authorColorSeed() | authorColor">
          <b>{{ authorDisplayName() }}</b>
        </div>
      </div>
      } @if (!hide) {
      <div>
        <p [innerHtml]="body || message.body || '' | emoji | sanitizeHtml" (click)="onBodyClick($event)"></p>
        @if (translaterService.verifyCanTranslate) { @if ( !message.translation && !message.isLoadingTranslation &&
        message.body && translaterService.verifyCanTranslate ) {
        <p (click)="translateMessage()" class="message__translation-title message__title-original">
          {{ 'NGX-MESSAGING.TRANSLATER.translate' | translate }}
        </p>
        } @if (message.isLoadingTranslation && translaterService.verifyCanTranslate) {
        <p class="message__translation-title message__title-original">
          {{ 'NGX-MESSAGING.TRANSLATER.translatingMessage' | translate }}
        </p>
        } @if (message.errorTranslation && translaterService.verifyCanTranslate) {
        <p class="message__translation-title message__title-error">
          {{ 'NGX-MESSAGING.TRANSLATER.error' | translate }}
        </p>
        } @if (message.translation && translaterService.verifyCanTranslate) {
        <div class="message__original" [ngClass]="{ message__original__outcoming: message.outcoming }">
          <span (click)="hideTranslation = !hideTranslation" class="message__translation-title message__title-original">{{
            (!hideTranslation ? 'NGX-MESSAGING.TRANSLATER.hideTranslation' : 'NGX-MESSAGING.TRANSLATER.showTranslation')
              | translate
          }}</span>
          @if (!hideTranslation) {
          <p class="message__content" [innerHtml]="message.translation | sanitizeHtml"></p>
          }
        </div>
        } }
      </div>
      }

      <div *hasWorkspaceFeature="[WorkspaceFeatures.canSeeHyperlinks]">
        @for (link of selectedWorkspace()?.config?.dynamicLinks; track link.url) {
        <div>
          @if ( link.previewTemplate === 'repairOrdersPreviewComponent' && getHyperlinkRepairOrder(body || message.body,
          getUrlLink(link.url)!, link.pattern) ) {
          <div class="message__hyperlinks">
            <ngx-repair-order
              [idRepairOrder]="getHyperlinkRepairOrder(body || message.body, getUrlLink(link.url)!, link.pattern)"
              [message]="message"></ngx-repair-order>
          </div>
          }
        </div>
        }
      </div>
      @if (videoCallRoom) {
      <div class="message__hyperlinks">
        <ngx-open-modal [room]="videoCallRoom"></ngx-open-modal>
      </div>
      } @for (attachment of message?.attachments; track attachment.uid) {
      <div class="message__attachment">
        <media-upload-msg [attachment]="attachment"></media-upload-msg>
      </div>
      }

      <div
        class="message__timestamp"
        [ngClass]="{
          'message-outcoming__timestamp': !message.outcoming
        }">
        @if (deliveryStatus === 'error' && selectedChannel()?.enabled) {
        <mat-icon
          [ngStyle]="{ cursor: 'pointer' }"
          class="message__timestamp__delivery-status"
          [svgIcon]="'reload'"
          matTooltip="{{ 'Resend message' | translate }}"
          (click)="resendMessage()"></mat-icon>
        }
        <ng-container *hasChannelFeature="[ChannelFeatures.canSeeDeliveryStatus]">
          @if (selectedChannel()?.type !== 'DIRECT_MESSAGE' || (selectedChannel()?.type === 'DIRECT_MESSAGE' &&
          message.outcoming)) {
          <mat-icon
            class="message__timestamp__delivery-status"
            [svgIcon]="deliveryStatus"
            [ngClass]="{
              'red-icon': deliveryStatus === 'error' && message.errorCode === 9902,
              'yellow-icon': deliveryStatus === 'error' && message.errorCode !== 9902,
              'primary-icon': $safeNavigationMigration(message?.deliveryStatus?.anyRead)
            }"
            matTooltip="{{ deliveryStatus === 'error' && message.errorMessage ? message.errorMessage : null }}"></mat-icon>
          }
        </ng-container>

        {{ $safeNavigationMigration(message?.createdAt) | dateByTimeZone : 'MM/dd/yy hh:mm:ss aa' }}
      </div>
    </div>
    <ng-container *hasWorkspaceFeature="[WorkspaceFeatures.canUseReactions]">
      <button
        type="button"
        class="message-container__reaction-selector"
        [attr.aria-label]="'NGX-MESSAGING.CHAT.addReaction' | translate"
        [class.message-container__reaction-selector--outcoming]="message.outcoming"
        (click)="openReactionSelector()">
        <mat-icon aria-hidden="true" class="message-container__reaction-selector__icon" svgIcon="emoji"></mat-icon>
      </button>
    </ng-container>
    <ng-container *hasWorkspaceFeature="[WorkspaceFeatures.canUseReactions]">
      @if (reactionsGroup?.length) {
      <div class="message-container__reactions" [class.message-container__reactions--outcoming]="message.outcoming">
        @for (reaction of reactionsGroup; track reaction.body) {
        <span
          matTooltip="{{ reaction.tooltip }}"
          class="message-container__reactions__reaction"
          [class.message-container__reactions__reaction--mine]="reaction.mine">
          <span class="message-container__reactions__emoji">{{ reaction.body }}</span>
          @if (reaction.reactions.length > 1) {
          <span class="message-container__reactions__count">{{ reaction.reactions.length }}</span>
          }
        </span>
        }
      </div>
      }
    </ng-container>
  </div>
</div>
